import React, { createContext, useContext, useState, useEffect } from "react";
import { logout as authLogout } from "../services/authService";
import { getSecureItem } from "../utils/LocalStorageManager";

interface UserContextType {
  user: any;
  setUser: (user: any) => void;
  logout: () => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    // On mount, load user from localStorage if token exists
    const token = getSecureItem("token");
    if (token) {
      const storedUser = getSecureItem("user");
      if (storedUser) setUser(storedUser);
    }
  }, []);

  const logout = async () => {
    await authLogout();
    setUser(null);
  };

  return (
    <UserContext.Provider value={{ user, setUser, logout }}>
      {children}
    </UserContext.Provider>
  );
};

// Custom hook for easier usage
export const  useUser = () => {
  const context = useContext(UserContext);
  if (!context) throw new Error("useUser must be used within a UserProvider");
  return context;
};
